/* unplugin-vue-components disabled */import script from "./ConfiguratorWrapper.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfiguratorWrapper.vue?vue&type=script&setup=true&lang=js"

import "./ConfiguratorWrapper.vue?vue&type=style&index=0&id=403c8f86&lang=scss"

const __exports__ = script;

export default __exports__